import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompareBlocks = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "#FFF",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", { d: "M15.278 17.836a.844.844 0 010 1.19.844.844 0 01-1.191 0l-4.169-4.168a.844.844 0 010-1.191l4.169-4.169a.844.844 0 011.191 0 .844.844 0 010 1.191l-2.734 2.734 6.31-.004a.843.843 0 11-.004 1.687l-6.303-.001 2.731 2.73zM5.97 12.395a.844.844 0 010-1.19L8.703 8.47l-6.308.004a.843.843 0 11.003-1.688l6.303.002L5.97 4.057a.844.844 0 010-1.19.844.844 0 011.19 0l4.17 4.168a.844.844 0 010 1.191l-4.17 4.17a.844.844 0 01-1.19 0z" })
	})
});
export default SvgCompareBlocks;
